export const UserRoles = {
  ABO: "ABO",
  FOA: "FOA",
};

export const LoggedInUserRole = "ABO";
export const ONE_PLUS_N_BUNDLE = "1+nBundle";
export const DEFAULT_BUNDLE = "defaultBundle";
export const M_PLUS_N_BUNDLE = "m+nBundle";
